<template>
  <div class="page page-my-data content">
    <h1 class="page__title">{{ str('myData.menuTitle') }}</h1>

    <Personalize />

    <a
      class="toggle-pw-reset button--secondary"
      @click="showResetPasswordForm = !showResetPasswordForm"
    >
      {{ str('global.changePassword') }}
    </a>
    <div :class="resetPasswordClasses()">
      <p
        v-if="changePasswordFinished()"
        v-html="$store.getters.formMessage('changePassword')"
      ></p>
      <p v-else>
        Wir senden ein E-Mail an "<em>{{
          $store.getters.contractData.email
        }}</em
        >", das einen Link zum Ändern deines Passworts enthält.
      </p>
      <LinkButton
        v-if="canDoPasswordReset()"
        :text="str('global.changePassword')"
        :icon-right="changePasswordSubmitIcon"
        form="changePassword"
        :disabled="changePasswordFinished()"
        :extra-classes="changePasswordButtonClasses()"
        @click.native="$store.dispatch('startChangePassword')"
      />
    </div>
    <ContractData />
  </div>
</template>

<script>
  import util from '@/js/Util'
  import ContractData from '@/components/settings/ContractData'
  import LinkButton from '@/components/LinkButton'
  import Personalize from '@/components/settings/Personalize'

  export default {
    name: 'page-my-data',
    components: {
      ContractData,
      LinkButton,
      Personalize,
    },
    data() {
      return {
        showResetPasswordForm: false,
      }
    },
    created() {
      if (!this.canDoPasswordReset()) {
        const message = this.str('authentication.passwordResetMailSent')
        this.$store.commit('setFormState', {
          form: 'changePassword',
          state: 'finished',
        })
        this.$store.commit('setFormMessage', {
          form: 'changePassword',
          message: message,
        })
      }
    },
    computed: {
      changePasswordSubmitIcon() {
        return this.changePasswordFinished() ? 'Check' : 'Arrow'
      },
    },
    methods: {
      changePasswordFinished() {
        const state = this.$store.getters.formState('changePassword')
        return state === 'finished'
      },
      resetPasswordClasses() {
        let classes = ['pw-reset']
        if (this.showResetPasswordForm) {
          classes.push('pw-reset--visible')
        }
        return classes.join(' ')
      },
      changePasswordButtonClasses() {
        let result = []
        if (this.changePasswordFinished()) {
          result.push('button--success')
        }
        return result
      },
      canDoPasswordReset() {
        const result = util.canDoPasswordReset()
        if (result) {
          this.$store.commit('setFormState', {
            form: 'changePassword',
            state: false,
          })
          this.$store.commit('setFormMessage', {
            form: 'changePassword',
            message: false,
          })
        }
        return result
      },
    },
  }
</script>

<style lang="scss" scoped>
  .page {
    max-width: $content-page-width;
  }

  .toggle-pw-reset {
    cursor: pointer;
  }

  .pw-reset {
    max-height: 0;
    overflow: hidden;
    transition: $transition-base;
    margin-top: spacer(1);
    margin-bottom: spacer(4);

    em {
      font-style: normal;
      font-weight: 600;
    }

    &--visible {
      max-height: 200px;
    }
  }
</style>
